import React, { useState, useEffect } from "react";
import useAppContext from "../../context/Context";
import "./Modal.css";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
const Modal = ({ content, changeModal }) => {
  useEffect(() => {
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
      initClassName: "aos-init", // class applied after initialization
      animatedClassName: "aos-animate", // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  }, []);

  return (
    <>
      <div
        data-aos="fade-down"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          height: "100%",
          background: "rgb(20 15 51 / 90%)",
          zIndex: "999999",
          position: "fixed",
          top: "0",
        }}
      >
        {content}
        <button
          onClick={changeModal}
          style={{
            height: "40px",
            width: "100px",
            position: "relative",
            right: "-27rem",
            top: "2.5rem",
            border: "none",
            background: "none",
            cursor: "pointer",
            zIndex: "99999999",
          }}
        >
          <svg
            style={{ background: "#fff", borderRadius: "50%" }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <svg style={{ width: "100%", height: "100%" }}>
              <path
                d="M17 7L7 17"
                stroke="rgb(114, 219, 170)"
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="round"
              />
              <path
                d="M7 7L17 17"
                stroke="rgb(114, 219, 170)"
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="round"
              />
            </svg>
          </svg>
        </button>
      </div>
    </>
  );
};
export default Modal;
